import { useNavigate, useLocation } from 'react-router-dom';
import { history, uxscreen } from '_services/essentials/helpers';
import { AppLayout, AppAlertBox } from '_components';
import { AccLayout } from '_pages/essentials/account/AccLayout';
import { Poster } from '_pages/web';
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import {breadcrumbsActions} from "./_services/essentials/store";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";

export { App };

function App() {
    // init custom history object to allow navigation from 
    // anywhere in the react app (inside or outside components)
    history.navigate = useNavigate();
    history.location = useLocation();
    const auth = useSelector(x => x.auth.value);

    const dispatch = useDispatch();

    if(history.location && history.location.pathname && history.location.pathname.trim() !=='/navigate') {
        // setTimeout(function() {
        //     alert(history.location.state ? JSON.stringify(history.location.state) : '');
        // }, 2000);
        dispatch(breadcrumbsActions.setCurrentURL(history.location.pathname));
    }

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            {auth ? (
                <AppLayout />
            ) : (
                <Stack direction={"row"} sx={{ width: '100%', height: '100%', justifyContent: 'space-between', flexGrow: '1', gap: 1 }}>
                    <Stack direction={"column"} sx={{
                        width: '50%',
                        // background: 'linear-gradient(to right, #09084d, #03527c)',
                    }}>
                        <Poster />
                    </Stack>
                    <Stack direction={"column"} sx={{ width: '50%', height: '100%' }}>
                        <Stack
                            direction={"column"}
                            sx={{
                                justifyContent: 'space-between',
                                Height: uxscreen.size1,
                            }}
                        >
                            {/* <WebNav/> */}
                            <AppAlertBox />
                        </Stack>
                        <Stack
                            direction={"column"}
                            // sx={{
                            //     justifyContent: 'space-between',
                            //     //                height: '100dvh',
                            //     height: uxscreen.size5,
                            //     verticalAlign: 'middle',
                            // }}
                            // spacing={2}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',

                            }}
                        >
                            <AccLayout />
                        </Stack>
                    </Stack>
                </Stack>
            )}
        </Box>
    );
}

